import RequestsService from "./RequestsService.js";

async function getTests() {
    return await RequestsService.get("tests");
}

export default {
    getTests: getTests,
};
